import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = { selectOptions: props.options };
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps != this.props) {
            this.setState({ selectOptions: nextProps.options });

            return true;
        }

        return false;
    }

    render() {
        let props = this.props;
        delete props.options;

        return (
            <select-group className={`${props.error ? 'has-error' : ''} ${props.label ? 'has-label' : ''}`}>
                {this.renderLabel()}
                {this.renderPlaceholder()}
                <select
                    {...props}
                    className={`${this.props.className} ${props.error ? 'error' : ''}`}
                    onBlur={this.blur}
                    ref={el => this.selectEl = el}
                >
                    {this.renderDefault()}
                    {this.renderOptions()}
                </select>
                {this.renderError()}
            </select-group>
        );
    }

    renderLabel = () => {
        if (this.props.label) {
            return (<label dangerouslySetInnerHTML={{__html: this.props.label}} />);
        }

        return null;
    }

    renderPlaceholder = () => {
        if (this.props.placeholder && !this.props.value) {
            return (<span onClick={this.focus}>{this.props.placeholder}</span>);
        }

        return null;
    }

    renderDefault = () => {
        if (!this.props.value) {
            if (this.props.default) {
                return (<option disabled selected>{this.props.default}</option>);
            }

            return (<option disabled selected />);
        }

        return null;
    }

    renderOptions = () => {
        if (this.state.selectOptions) {
            if (this.props.sortBy) {
                if (this.props.sortBy == 'alpha') {
                    if (Array.isArray(this.state.selectOptions)) {
                        return this.state.selectOptions.sort().map(option => {
                            const value = option.toString().replace(/"/g, '');
                            return this.renderOption(value, option);
                        });
                    } else if (typeof this.state.selectOptions === 'object') {
                        return Object.values(this.state.selectOptions).sort().map(alpha  => {
                            const key = Object.keys(this.state.selectOptions).find(k => this.state.selectOptions[k] === alpha); // eslint-disable-line max-len
                            const value = key.toString().replace(/"/g, '');
                            return this.renderOption(value, this.state.selectOptions[key]);
                        });
                    }
                }
            } else {
                if (Array.isArray(this.state.selectOptions)) {
                    return this.state.selectOptions.map(option => {
                        const value = option.toString().replace(/"/g, '');
                        return this.renderOption(value, option);
                    });
                } else if (typeof this.state.selectOptions === 'object') {
                    return Object.keys(this.state.selectOptions).map(key => {
                        const value = key.toString().replace(/"/g, '');
                        return this.renderOption(value, this.state.selectOptions[key]);
                    });
                }
            }
        }

        return null;
    }

    renderOption = (value, name) => {
        value = value.toString().replace(/"/g, '');

        return (
            <option
                value={value}
                selected={this.props.value && this.props.value == value}
            >{name}</option>
        );
    }

    renderError = () => {
        if (this.props.error) {
            return (
                <p className='is-error'>{this.props.error}</p>
            );
        }

        return null;
    }
}

export default connect()(Component);